import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';

import { AppleWifiProfilePreset } from '@rocksoft/mdm-sdk-v2';

export type WifiProfileState = EntityState<AppleWifiProfilePreset>;

export function selectIdFromWifiProfile(conf: AppleWifiProfilePreset): string {
  return conf.uniqueId;
}

export const adapter: EntityAdapter<AppleWifiProfilePreset> = createEntityAdapter<AppleWifiProfilePreset>({
  selectId: selectIdFromWifiProfile,
});

export const initialState: WifiProfileState = adapter.getInitialState();
